import { useCallback, useMemo } from 'react';
import { LocalStorageWrapper } from 'lib/local-storage';

const RECENTLY_VIEWED_KEY = 'user_recently_viewed';

type RecentlyViewedItem = {
  id: string;
  type: 'contact' | 'flow' | 'job' | 'interview';
  details: any;
};

export const useRecentlyViewedTracking = (limit: number = 10) => {
  const getAllItems = useCallback((): RecentlyViewedItem[] => {
    const raw = LocalStorageWrapper.getItem(RECENTLY_VIEWED_KEY);
    return raw ? (raw as RecentlyViewedItem[]) : [];
  }, []);

  const trackRecentlyViewed = useCallback(
    (item: RecentlyViewedItem) => {
      const current = getAllItems();
      const filtered =
        current?.filter((i) => !(i.id === item.id && i.type === item.type)) ||
        [];

      const updated = [item, ...filtered].slice(0, limit);
      LocalStorageWrapper.setItem(RECENTLY_VIEWED_KEY, updated);
    },
    [getAllItems, limit]
  );

  const getByType = useCallback(
    (type: string): RecentlyViewedItem[] => {
      return getAllItems().filter((item) => item.type === type);
    },
    [getAllItems]
  );

  const allItems = useMemo(() => getAllItems(), [getAllItems]);

  return {
    trackRecentlyViewed,
    getRecentlyViewedByType: getByType,
    recentlyViewed: allItems,
  };
};
